import { AUTH_PROVIDERS } from "utils/constants";
import { getAuthDescriptor } from "utils/helpers/authProvider";
import { API_ORIGIN } from "utils/helpers/apiOrigin";
import CredentialsForm from "./CredentialsForm";
import ZitadelButton from "./ZitadelButton";

// kayros-id: no server-side session to revoke, just clear local state/cache.
const kayrosIdLogout = async ({ clearStore, client }) => {
  clearStore();
  await client.clearStore().catch(() => {});
};

// Zitadel: revoke the server-side cookie session, then clear local state/cache.
const zitadelLogout = async ({ clearStore, client }) => {
  clearStore();
  await fetch(`${API_ORIGIN}/api/auth/zitadel/logout`, {
    method: "POST",
    credentials: "include",
  }).catch(() => {});
  await client.clearStore().catch(() => {});
};

// Frontend behaviour per provider. Add a new provider by adding an entry here
// (matching its API `key`) with a LoginComponent and a logout handler.
const PROVIDERS = {
  [AUTH_PROVIDERS.KAYROS_ID]: {
    key: AUTH_PROVIDERS.KAYROS_ID,
    strategy: "credentials",
    LoginComponent: CredentialsForm,
    logout: kayrosIdLogout,
  },
  [AUTH_PROVIDERS.ZITADEL]: {
    key: AUTH_PROVIDERS.ZITADEL,
    strategy: "redirect",
    LoginComponent: ZitadelButton,
    logout: zitadelLogout,
  },
};

export const getProvider = (key) =>
  PROVIDERS[key] || PROVIDERS[AUTH_PROVIDERS.KAYROS_ID];

export const getActiveProvider = () =>
  getProvider(getAuthDescriptor().provider);
